// extracted by mini-css-extract-plugin
module.exports = {"dashbord":"styles_dashbord__3WaAE"};